export const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    // maxWidth: '1440px',
    padding: 'clamp(1rem, 2vw, 3rem)',
    backgroundColor: '#000',
    // margin: '0 auto',
  },
  cardOuterBorder: {
    position: 'relative',
    borderRadius: '30px',
    background: 'linear-gradient(to bottom left, rgba(217, 217, 217, 0.4) 0%, rgba(217, 217, 217, 0.1) 100%)',
    padding: '0.04rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    position: 'relative',
    width: 'clamp(320px, 90vw, 1280px)',
    minHeight: 'clamp(200px, 45vw, 720px)',
    borderRadius: '30px',
    overflow: 'hidden',
  },
  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
  },
  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(100px)',
    zIndex: 2,
  },
  form: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 'clamp(1rem, 2vw, 3rem)',
    gap: 'clamp(1rem, 2vw, 3rem)',
    zIndex: 3,
  },
  leftColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(1rem, 1.5vw, 2rem)',
  },
  inputCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    padding: '0 clamp(1rem, 2vw, 3rem)',
    borderRadius: '25px',
  },
  inputCardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(10px)',
    zIndex: 2,
  },
  rightColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(1rem, 1.5vw, 2rem)',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingTop: 'clamp(0.5rem, 1.5vw, 2rem)',
    paddingLeft: 'clamp(0.2rem, 0.4vw, 1rem)',
    marginBottom: 'clamp(1rem, 2vw, 3rem)',
  },
  title: {
    fontFamily: 'Orbitron, sans-serif',
    fontWeight: '200',
    fontSize: 'clamp(1rem, 1.8vw, 2.5rem)',
    margin: 0,
    color: '#fff',
  },
  titleBar: {
    flex: 1,
    height: '4px',
    backgroundColor: '#fff',
    opacity: 0.8,
    marginLeft: 'clamp(0.5rem, 1vw, 2rem)',
    marginBottom: 'clamp(0.2rem, 0.5vw, 1rem)',
  },
  rightTitleBar: {
    flex: 1,
    height: '4px',
    backgroundColor: '#fff',
    opacity: 0.8,
    marginBottom: 'clamp(0.2rem, 0.5vw, 1rem)',
    marginTop: 'clamp(1.5rem, 3vw, 4rem)',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(0.4rem, 0.7vw, 1rem)',
    marginBottom: 'clamp(1rem, 2vw, 3rem)',
  },
  label: {
    fontSize: 'clamp(0.8rem, 1vw, 1.2rem)',
    fontWeight: '500',
    color: '#fff',
    paddingLeft: 'clamp(0.3rem, 0.5vw, 1rem)',
    fontFamily: 'Orbitron, sans-serif',
  },
  input: {
    padding: 'clamp(0.5rem, 0.7vw, 1rem)',
    paddingLeft: 'clamp(0.5rem, 1vw, 1.5rem)',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    color: 'rgba(255, 255, 255, 0.75)',
  },
  submitButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'clamp(0.5rem, 1vw, 1.5rem) clamp(1rem, 2vw, 3rem)',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '50px',
    color: '#fff',
    fontSize: 'clamp(1rem, 1.2vw, 1.5rem)',
    fontWeight: 'bold',
    transition: 'background 0.3s ease',
    margin: '0 auto',
    marginTop: 'clamp(-1rem, -0.8vw, 0rem)',
  },
  submitButtonEnabled: {
    backgroundColor: '#F68500',
    color: '#FFF',
    cursor: 'pointer',
    boxShadow: 'inset 0px 4px 6px rgba(255, 255, 255, 0.3), inset 0px -4px 6px rgba(0, 0, 0, 0.4)',
  },
  icon: {
    marginLeft: 'clamp(0.3rem, 0.5vw, 1rem)',
    fontSize: 'clamp(1rem, 1.2vw, 1.5rem)',
  },
  captchaWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'clamp(-1rem, -0.5vw, 0rem)',

  },
  group: {
    marginBottom: 'clamp(0.5rem, 1vw, 1.5rem)',
    marginTop: 'clamp(1rem, 2.2vw, 3rem)',
  },
  options: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'clamp(0.3rem, 0.5vw, 1rem)',
    marginTop: 'clamp(0.5rem, 1vw, 2rem)',
  },
  optionButton: {
    padding: 'clamp(0.5rem, 0.75vw, 1rem) clamp(1rem, 1.25vw, 2rem)',
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    border: 'none',
    borderRadius: '20px',
    color: 'rgba(255, 255, 255, 0.75)',
    cursor: 'pointer',
  },
  optionButtonActive: {
    backgroundColor: '#F68500',
    color: '#fff',
  },
  inputError: {
    border: '2px solid #FF3B30',
    boxShadow: '0px 0px 6px rgba(255, 59, 48, 0.6)',
  },
  errorMessage: {
    color: '#FF3B30',
    fontSize: 'clamp(0.6rem, 0.8vw, 1rem)',
    marginTop: 'clamp(0rem, 0.1vw, 0.3rem)',
    marginLeft: 'clamp(0.3rem, 0.5vw, 1rem)',
  },
};
